import { Component, Input } from '@angular/core';
import { UtilsService } from '@shared/providers/utils.service';

export interface IDetailItensInformations {
  evaluationDetailItemAdditionalAttributes: string;
  evaluationDetailItemConservationState: string;
  evaluationDetailItemCreatedAt: string;
  evaluationDetailItemMaintenanceCostInCents: number;
  evaluationDetailItemMaintenanceDate: string;
  evaluationDetailItemMaintenanceRequested: boolean;
  evaluationDetailItemMaintenanceResponsible: string;
  evaluationDetailItemQuantity: number;
  evaluationDetailsItemsPhotos: [];
  evaluationSurveyElementItemId: number;
  maintenancePriorityType: any;
}

@Component({
  selector: 'app-detail-items-informations',
  templateUrl: './detail-items-informations.component.html',
  styleUrls: ['./detail-items-informations.component.scss'],
})
export class DetailItemsInformationsComponent {
  @Input() informations: IDetailItensInformations;
  constructor(public utils: UtilsService) {}
}
